import { useEffect, useState } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { GetOrderVehicleStatus } from "../../../services/Api/vehicles";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";
import PlateOrdered from "./PlateOrdered";
import {formatPlateBR} from '../../../helpers/util';

export default function Plate({ licensePlate, onPress, inYard }) {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [orderVehicle, setOrderVehicle] = useState();
  useEffect(
    () =>
      inYard
        ? getOrderVehicleStatus(licensePlate.toString().replace("-", ""))
        : undefined,
    [inYard]
  );

  const getOrderVehicleStatus = (plate) => {
    GetOrderVehicleStatus(plate)
      .then((value) => {
        setOrderVehicle(value.result);
      })
      .catch((error) => {
        setOrderVehicle(null);
        setElapsedTime(0);
      });
  };

  useEffect(() => {
    if (!orderVehicle) return;
    const interval = setInterval(() => {
      setElapsedTime((prevTime) => (prevTime + 1) % 61); // Reinicie quando chegar a 60 segundos
      if (elapsedTime === 59) {
        getOrderVehicleStatus(licensePlate.toString().replace("-", ""));
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [orderVehicle, elapsedTime]);

  if (orderVehicle)
    return (
      <PlateOrdered
        orderVehicle={orderVehicle}
        elapsedTime={elapsedTime}
        licensePlate={licensePlate}
      />
    );

  return (
    <View style={styles.principalView}>
      <View style={styles.subView}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flex: 1,
            justifyContent: "space-between",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon name="car-outline" size={24} />
            <View style={styles.infoView}>
              <Text style={styles.titleText}>{"Placa"}</Text>
              <Text style={styles.plateText}>{formatPlateBR(licensePlate)}</Text>
            </View>
          </View>
        </View>
        <TouchableOpacity
          style={[
            styles.infoButton,
            {
              backgroundColor: inYard ? Colors.WARNING : Colors.GRAY_DARK,
            },
          ]}
          onPress={onPress}
          activeOpacity={inYard ? null : 1}
        >
          <Icon name="arrow-up-right" size={24} color={Colors.WHITE} />
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  principalView: {
    borderRadius: 8,
    marginVertical: 8,
    padding: 8,
    backgroundColor: Colors.SNOW,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  subView: {
    flexDirection: "row",
    alignItems: "center",
    alignItems: "center",
  },
  infoView: {
    marginLeft: 8,
  },
  titleText: {
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "300",
    color: Colors.BLACK,
  },
  plateText: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "500",
    color: Colors.SECONDARY,
  },
  infoButton: {
    marginLeft: "auto",
    padding: 8,
    borderRadius: 4,
    backgroundColor: Colors.WARNING,
  },
  line: {
    height: 4,
    backgroundColor: Colors.PRIMARY,
    borderRadius: 4,
    marginTop: 4,
  },
});
